import { render, staticRenderFns } from "./IncreaseItemCart.vue?vue&type=template&id=8f6f5c96&scoped=true"
import script from "./IncreaseItemCart.vue?vue&type=script&lang=ts"
export * from "./IncreaseItemCart.vue?vue&type=script&lang=ts"
import style0 from "./IncreaseItemCart.vue?vue&type=style&index=0&id=8f6f5c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6f5c96",
  null
  
)

export default component.exports